var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistsHuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24.75C8 23.7835 8.7835 23 9.75 23H86.25C87.2165 23 88 23.7835 88 24.75C88 25.7165 87.2165 26.5 86.25 26.5H9.75C8.7835 26.5 8 25.7165 8 24.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 40.25C8 39.2835 8.7835 38.5 9.75 38.5H86.25C87.2165 38.5 88 39.2835 88 40.25C88 41.2165 87.2165 42 86.25 42H9.75C8.7835 42 8 41.2165 8 40.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 54C8.7835 54 8 54.7835 8 55.75C8 56.7165 8.7835 57.5 9.75 57.5H56.5774C57.5438 57.5 58.3274 56.7165 58.3274 55.75C58.3274 54.7835 57.5438 54 56.5774 54H9.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 71.25C8 70.2835 8.7835 69.5 9.75 69.5H56.5774C57.5438 69.5 58.3274 70.2835 58.3274 71.25C58.3274 72.2165 57.5438 73 56.5774 73H9.75C8.7835 73 8 72.2165 8 71.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.626 65.9081C88.522 64.8625 88.522 62.1375 86.626 61.0919L74.3859 54.3416C72.5531 53.3309 70.3078 54.6567 70.3078 56.7497V70.2503C70.3078 72.3433 72.5531 73.6691 74.3859 72.6584L86.626 65.9081ZM73.8078 58.0198L83.745 63.5L73.8078 68.9802V58.0198Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistsHuge);
export default __webpack_public_path__ + "static/media/playlists-huge.114600d5ab5984caf742325457129686.svg";
export { ForwardRef as ReactComponent };